/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import useStyles from './styles';
import Pie from '../Charts/Pie';

const kpis = [
  {
    number: '80',
    text: 'NO VIS. MIN.<br>OR INDIG.',
    color: '#75798E',
  },
  {
    number: '15',
    text: 'ONE VIS. MIN.<br>OR INDIG.',
    color: '#D9A798',
  },
  {
    number: '5',
    text: 'MORE THAN ONE VIS. MIN.<br>OR INDIG.',
    color: '#95CFC2',
  },
];

const PieSection = ({ header, text }) => {
  const classes = useStyles();

  return (
    <div className="section" style={{ marginTop: 50 }}>
      <Typography variant="h3" className={classes.header}>{header}</Typography>
      <Typography variant="body1" className={classes.text}>{text}</Typography>
      <Box className={classes.kpis}>
        {kpis.map((kpi) => (
          <Box className={classes.kpi} key={kpi.number}>
            <Typography variant="body2" className={classes.kpiNumber} style={{ color: kpi.color }} dangerouslySetInnerHTML={{ __html: `${kpi.number}<span style="font-size: 16px; position: relative; top: -4px;">%</span>` }} />
            <Typography variant="body1" className={classes.kpiText}>
              OF NEWSROOMS HAVE
              <span className={classes.kpiValue} dangerouslySetInnerHTML={{ __html: kpi.text }} />
              IN A TOP LEADERSHIP ROLE
            </Typography>
            <div className={classes.divider} style={{ backgroundColor: kpi.color }} />
          </Box>
        ))}

      </Box>
      <Box className={classes.chartsWrapper}>
        <Typography variant="body1" className={classes.chartTitle}>Percentage of Newsrooms</Typography>
        <Box className={classes.chartsContainer}>
          <Pie />
        </Box>
      </Box>

    </div>
  );
};

PieSection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

PieSection.defaultProps = {
  header: '',
  text: '',
};

export default PieSection;
